// extracted by mini-css-extract-plugin
module.exports = {"root":"m20category_root__CqP17","mediaWrapper":"m20category_mediaWrapper__8L4OC","image":"m20category_image__rd8WH","textBlock":"m20category_textBlock__9HoOf"};